"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _qrcode = require("qrcode");

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    renderQrCode: function renderQrCode(element, code) {
      _qrcode2.default.toCanvas(element, code, { width: 200, height: 200 });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/mixins/qrCode.js
// module id = 7wQG
// module chunks = 0 1